// @ts-nocheck
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Modal, Button, Form } from 'react-bootstrap';
import Table from 'react-bootstrap/Table';
import Spinner from 'react-bootstrap/Spinner';
import Select, { components } from 'react-select';
import { getRequestOptions, postRequestOptions } from '../helpers/Fetchwrapper';
import AsyncSelect from 'react-select/async'
import { Link } from 'react-router-dom';
import { numberFormat } from '../helpers/GlobalHelper';

interface FormData {
    voucherDate: string;
    voucherType: string;
    idProjects: string;
    idSr: string;
    idModeOfTransaction: string | null;
    chequeNo: string;
    chequeDate: string;
    transactionDate: string;
    narration: string;
}

// Define the shape of the ledger entry
interface ICostCenterAllocation {
    costCenter: any | null;
    costCenterId?: number;
    costCenterName?: string;
    amount: string;
    remarks: string;
}

interface ILedgerEntry {
    ledger: any;
    drAmount: string;
    crAmount: string;
    remarks: string;
    costCenters: ICostCenterAllocation[];
}

interface JournalProps {
    show: boolean;
    handleClose: (show: boolean) => void;
    id: number;
    cloneFromVoucherId?: number;
}

const LedgerSingleValue = (props: any) => (
    <components.SingleValue {...props}>
        <div className='row'>
            <span> {props.data.label} </span>
            {props.data.balance && (
                <span className='text-muted small ms-1'> ({props.data.balance})</span>
            )}
        </div>
    </components.SingleValue>
)

const normalizeAmount = (value: any): string => {
    if (value === null || value === undefined || value === '') return '';
    const n = Number(value);
    return Number.isNaN(n) ? String(value) : n.toString();
};

const JournalModal: React.FC<JournalProps> = ({ show, handleClose, id, cloneFromVoucherId }) => {

    const [isSubmitDisable] = useState(false);
    const [loading, setLoading] = useState(false);

    const [projects, setProjects] = useState([]);
    const [project, setProject] = useState({ label: 'Select Project', value: '' });

    const [companySelectAbility, setCompanySelectAbility] = useState(false);
    const [srs, setSrs] = useState([]);
    const [sr, setSr] = useState({ label: 'Select SR', value: '' });

    const voucherTypes = [
        { value: 'journal', label: 'Journal' },
        { value: 'contra', label: 'Contra' },
        { value: 'payment', label: 'Payment' },
        { value: 'receipt', label: 'Receipt' },
    ];

    const [voucherType, setVoucherType] = useState({ label: 'Journal', value: 'journal' });

    const [modeOfTransactions, setModeOfTransactions] = useState([]);
    const [modeOfTransaction, setModeOfTransaction] = useState({ label: 'Select Mode of Transaction', value: '' });

    const [defaultLedgers, setDefaultLedgers] = useState([]);

    // Define state for form fields here
    const [formData, setFormData] = useState<FormData>({
        voucherDate: '',
        voucherType: 'journal',
        idProjects: '',
        idSr: '',
        idModeOfTransaction: null,
        chequeNo: '',
        chequeDate: '',
        transactionDate: '',
        narration: '',
    });

    // Define state for form fields here
    const createEmptyEntry = (): ILedgerEntry => ({ ledger: null, drAmount: '', crAmount: '', remarks: '', costCenters: [] });
    const [entries, setEntries] = useState<ILedgerEntry[]>([
        createEmptyEntry(),
    ]);
    const [costCenterOptions, setCostCenterOptions] = useState<any[]>([]);
    const [showCostCenterModal, setShowCostCenterModal] = useState(false);
    const [activeCostCenterIndex, setActiveCostCenterIndex] = useState<number | null>(null);
    const createEmptyCostCenterRow = (): ICostCenterAllocation => ({
        costCenter: null,
        costCenterId: undefined,
        costCenterName: undefined,
        amount: '',
        remarks: '',
    });
    const [costCenterRows, setCostCenterRows] = useState<ICostCenterAllocation[]>([createEmptyCostCenterRow()]);

    useEffect(() => {
        if (!cloneFromVoucherId) {
            setEntries([createEmptyEntry()]);
            setDefaultLedgers([]);
            setCostCenterRows([createEmptyCostCenterRow()]);
        }
    }, [id]);

    // Load voucher data when opening in clone mode
    useEffect(() => {
        if (!show || !cloneFromVoucherId) return;
        setLoading(true);
        fetch(process.env.REACT_APP_API_URL + 'transaction/edit/' + cloneFromVoucherId, getRequestOptions())
            .then((res) => res.json())
            .then((resp) => {
                if (!resp.success || !resp.data) {
                    toast('Failed to load voucher for cloning.', { type: 'error', position: 'bottom-right', autoClose: 3000 });
                    setLoading(false);
                    return;
                }
                const d = resp.data;
                const proj = d.project ? { label: d.project.projectName, value: d.idProjects } : { label: 'Select Project', value: '' };
                setProject(proj);
                setVoucherType({ label: (d.voucherType || 'journal').charAt(0).toUpperCase() + (d.voucherType || 'journal').slice(1), value: d.voucherType || 'journal' });
                const today = new Date().toISOString().split('T')[0];
                setFormData({
                    voucherDate: today,
                    voucherType: d.voucherType || 'journal',
                    idProjects: String(d.idProjects || ''),
                    idSr: d.idSr ? String(d.idSr) : '',
                    idModeOfTransaction: d.idModeOfTransaction ? String(d.idModeOfTransaction) : null,
                    chequeNo: d.chequeNo ?? '',
                    chequeDate: d.chequeDate ?? '',
                    transactionDate: d.transactionDate ?? '',
                    narration: d.narration ?? '',
                });
                if (d.mode_of_transaction || d.modeOfTransaction) {
                    const mot = d.mode_of_transaction || d.modeOfTransaction;
                    setModeOfTransaction({
                        label: mot.transactionName || mot.transaction_name,
                        value: d.idModeOfTransaction,
                    });
                } else {
                    setModeOfTransaction({ label: 'Select Mode of Transaction', value: '' });
                }
                const rows = (d.voucher_rows || d.voucherRows || []).map((item: any) => {
                    const ledger = item.ledger
                        ? {
                            id: item.ledger.id_acc_ledgers,
                            label: `${item.ledger.ledgerCode || ''} ${item.ledger.ledgerName || ''}`.trim(),
                            value: item.ledger.id_acc_ledgers,
                            idBankCash: item.ledger.idBankCash ?? item.ledger.id_bank_cash,
                            ledgerPath: item.ledger.ledgerPath ?? item.ledger.ledger_path,
                            balance: item.ledger.balance,
                        }
                        : null;
                    const costCenters: ICostCenterAllocation[] = (item.cost_center_maps || item.costCenterMaps || []).map((map: any) => ({
                        costCenter: map.cost_center ? { value: map.cost_center.id_cost_centers, label: map.cost_center.name } : (map.costCenter ? { value: map.costCenter.id_cost_centers, label: map.costCenter.name } : null),
                        costCenterId: map.id_cost_centers ?? map.costCenter?.id_cost_centers,
                        costCenterName: map.cost_center?.name ?? map.costCenter?.name,
                        amount: normalizeAmount(map.amount),
                        remarks: map.remarks ?? '',
                    }));
                    return {
                        ledger,
                        drAmount: normalizeAmount(item.dr_amount),
                        crAmount: normalizeAmount(item.cr_amount),
                        remarks: item.remarks ?? '',
                        costCenters,
                    };
                });
                setEntries(rows.length ? rows : [createEmptyEntry()]);
                if (d.idProjects) {
                    getProjectSrs(d.idProjects);
                    getCostCenters(d.idProjects);
                }
                if (d.sales_representative) {
                    const rep = d.sales_representative;
                    setSr({ label: [rep.firstName, rep.lastName].filter(Boolean).join(' '), value: rep.id });
                } else {
                    setSr({ label: 'Select SR', value: '' });
                }
                setDefaultLedgers(rows.map((r: any) => r.ledger).filter(Boolean));
            })
            .catch((err) => {
                console.error(err);
                toast('Failed to load voucher for cloning.', { type: 'error', position: 'bottom-right', autoClose: 3000 });
            })
            .finally(() => setLoading(false));
    }, [show, cloneFromVoucherId]);

    useEffect(() => {
        getProjects();
        getModeOfTransactions();
    }, [])

    const getModeOfTransactions = () => {
        fetch(process.env.REACT_APP_API_URL + 'mode-of-transactions', getRequestOptions())
            .then((resp) => resp.json())
            .then((resp) => {
                if (resp.success) {
                    setModeOfTransactions(
                        (resp.data || []).map((item: any) => ({
                            label: item.name,
                            value: item.id,
                        }))
                    );
                }
            })
            .catch((error) => {
                console.log(error, 'catch the hoop');
            });
    };

    const isChequeMode = (mode: any) => {
        return mode && String(mode.label).toLowerCase() === 'cheque';
    };

    useEffect(() => {
        if (cloneFromVoucherId) return;
        if (projects.length > 0) {
            const defaultProject = projects[0];
            setProject(defaultProject);
            setFormData((prev) => ({
                ...prev,
                idProjects: defaultProject.value,
            }));
            setEntries([createEmptyEntry()]);
            setCostCenterRows([createEmptyCostCenterRow()]);
            getProjectSrs(defaultProject.value);
            getCostCenters(defaultProject.value);
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [projects])


    const getProjects = () => {
        fetch(
            process.env.REACT_APP_API_URL + 'lead/projects',
            getRequestOptions()
        )
            .then((resp) => {
                return resp.json()
            })
            .then((resp) => {
                let projectObj = resp.data.map((item: any) => {
                    item.label = item.name;
                    item.value = item.id;
                    return item
                })
                setProjects(projectObj);
            })
            .catch((error) => {
                console.log(error, 'catch the hoop')
            })
    }

    const getCostCenters = (idProjects: string) => {
        const params = new URLSearchParams();
        if (idProjects) {
            params.append('idProjects', idProjects);
        }
        const url = `${process.env.REACT_APP_API_URL}cost-centers${params.toString() ? `?${params.toString()}` : ''}`;
        fetch(url, getRequestOptions())
            .then((resp) => resp.json())
            .then((resp) => {
                const options = (resp?.data || []).map((item: any) => ({
                    label: item.name,
                    value: item.idCostCenters,
                }));

                const existingSelections: any[] = [];
                entries.forEach((entry) => {
                    (entry.costCenters || []).forEach((allocation) => {
                        const value = allocation.costCenter?.value ?? allocation.costCenterId;
                        const label = allocation.costCenter?.label ?? allocation.costCenterName;
                        if (value && label) {
                            existingSelections.push({ value, label });
                        }
                    });
                });

                const merged = [...options];
                existingSelections.forEach((selection) => {
                    if (!merged.find((opt) => opt.value === selection.value)) {
                        merged.push(selection);
                    }
                });

                setCostCenterOptions(merged);
            })
            .catch((error) => {
                console.log(error, 'fetch cost centers error');
                setCostCenterOptions([]);
            });
    };

    const getLedgers = (inputValue: any, callback: any, voucherType = '') => {
        voucherType = voucherType === '' ? formData.voucherType : voucherType;

        let url = '';
        if (!inputValue) {
            url = `${process.env.REACT_APP_API_URL}transaction/ledgers?type=` + voucherType+`&idProjects=`+formData.idProjects;
        }
        else {
            url = `${process.env.REACT_APP_API_URL}transaction/ledgers?type=` + voucherType+`&idProjects=`+formData.idProjects + `&q=` + inputValue;
        }
        setTimeout(() => {
            fetch(url,
                getRequestOptions())
                .then((resp) => {
                    return resp.json()
                })
                .then((resp) => {
                    if (resp.data !== null) {
                        let tempArray = resp.data.map(function (element: any) {
                            element.label = `${element.ledgerCode} ${element.ledgerName}`;
                            element.value = element.idAccLedgers;
                            // element.ledgerPath = element.ledgerPath;
                            return element;
                        });
                        setDefaultLedgers(tempArray);
                        callback(tempArray);
                    }
                    else {
                        callback([]);
                    }
                })
                .catch((error) => {
                    console.log(error, "catch the hoop")
                });
        })


    }

    const getProjectSrs = (idProjects: number) => {
        fetch(
            process.env.REACT_APP_API_URL + 'getAllSr?idProjects=' + idProjects,
            getRequestOptions()
        )
            .then((resp) => {
                return resp.json()
            })
            .then((resp) => {
                let srsObj = resp.map((item: any) => {
                    item.label = item.first_name + ' ' + item.last_name;
                    item.value = item.id;
                    return item
                })
                setSrs(srsObj);
            })
            .catch((error) => {
                console.log(error, 'catch the hoop')
            })
    }

    const handleSrChange = (sr: any) => {
        setSr(sr);
        setFormData({ ...formData, idSr: sr.value });
    }

    // Handle project change
    const handleProjectChange = (project: any) => {
        setProject(project);
        if (project) {
            setFormData((prev) => ({ ...prev, idProjects: project.value }));
            getProjectSrs(project.value);
            getCostCenters(project.value);
            setEntries((prev) => prev.map((entry) => ({ ...entry, costCenters: [] })));
            setCostCenterRows([createEmptyCostCenterRow()]);
        } else {
            setFormData((prev) => ({ ...prev, idProjects: '' }));
            setCostCenterOptions([]);
            setEntries((prev) => prev.map((entry) => ({ ...entry, costCenters: [] })));
            setCostCenterRows([createEmptyCostCenterRow()]);
        }
        setCompanySelectAbility(false)
    }

    // Handle voucher type change
    const handleVoucherTypeChange = (voucherType: any) => {
        setVoucherType(voucherType);
        const isJournal = voucherType?.value === 'journal';
        if (isJournal) {
            setModeOfTransaction({ label: 'Select Mode of Transaction', value: '' });
        }
        setFormData({
            ...formData,
            voucherType: voucherType.value,
            ...(isJournal ? {
                idModeOfTransaction: null,
                chequeNo: '',
                chequeDate: '',
                transactionDate: '',
            } : {}),
        });
        setEntries([createEmptyEntry()]);
        setCostCenterRows([createEmptyCostCenterRow()]);
        getLedgers('', (data: any) => { }, voucherType.value);
    };

    const handleModeOfTransactionChange = (selected: any) => {
        if (!selected) {
            setModeOfTransaction({ label: 'Select Mode of Transaction', value: '' });
            setFormData((prev) => ({
                ...prev,
                idModeOfTransaction: null,
                chequeNo: '',
                chequeDate: '',
                transactionDate: '',
            }));
            return;
        }
        setModeOfTransaction(selected);
        const cheque = isChequeMode(selected);
        setFormData((prev) => ({
            ...prev,
            idModeOfTransaction: selected.value,
            chequeNo: cheque ? prev.chequeNo : '',
            chequeDate: cheque ? prev.chequeDate : '',
            transactionDate: cheque ? '' : prev.transactionDate,
        }));
    };

    // Handle input changes
    const handleInputChange = (index: number, event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        const newEntries = [...entries];
        const { name, value } = event.target;

        const currentEntry = { ...newEntries[index] };
        if (name === 'drAmount') {
            currentEntry.drAmount = value;
            currentEntry.crAmount = ''; // Clearing Credit Amount if Debit Amount is entered
        } else if (name === 'crAmount') {
            currentEntry.crAmount = value;
            currentEntry.drAmount = ''; // Clearing Debit Amount if Credit Amount is entered
        } else {
            // Assuming ILedgerEntry has a type definition that includes [key: string]: any
            currentEntry[name as keyof ILedgerEntry] = value;
        }

        newEntries[index] = currentEntry; // Correctly updating the entry at the given index
        setEntries(newEntries);

    };

    // Handle adding new row
    const handleAddRow = () => {
        setEntries([...entries, createEmptyEntry()]);
    };

    // Handle removing row
    const handleRemoveRow = (index: number) => {
        const newEntries = [...entries];
        newEntries.splice(index, 1);
        setEntries(newEntries.length ? newEntries : [createEmptyEntry()]);
    };

    // Handle ledger change
    const handleLedgerChange = (selectedOption: any, index: number) => {
        const updatedEntries = entries.map((entry, idx) => {
            if (idx === index) {
                return { ...entry, ledger: selectedOption, drAmount: '', crAmount: '', costCenters: [] };
            }
            return entry;
        });

        setEntries(updatedEntries);
    };

    const handleOpenCostCenterModal = (index: number) => {
        if (!entries[index]?.ledger) {
            toast('Please select a ledger first.', { type: 'error', position: 'bottom-right', autoClose: 3000 });
            return;
        }
        if (!formData.idProjects) {
            toast('Please select a project first.', { type: 'error', position: 'bottom-right', autoClose: 3000 });
            return;
        }
        if (!costCenterOptions.length) {
            getCostCenters(formData.idProjects);
        }
        setActiveCostCenterIndex(index);
        const existing = entries[index]?.costCenters || [];
        const rows = existing.length
            ? existing.map((row) => {
                const resolvedOption =
                    costCenterOptions.find((opt) => opt.value === (row.costCenter?.value ?? row.costCenterId)) ||
                    row.costCenter ||
                    (row.costCenterId ? { value: row.costCenterId, label: row.costCenterName } : null);
                return {
                    costCenter: resolvedOption,
                    costCenterId: resolvedOption?.value ?? row.costCenterId,
                    costCenterName: resolvedOption?.label ?? row.costCenterName,
                    amount: row.amount ?? '',
                    remarks: row.remarks ?? '',
                };
            })
            : [createEmptyCostCenterRow()];
        setCostCenterRows(rows);
        setShowCostCenterModal(true);
    };

    const handleCostCenterFieldChange = (index: number, field: 'costCenter' | 'amount' | 'remarks', value: any) => {
        setCostCenterRows((prev) => {
            const rows = [...prev];
            const row = { ...rows[index] };
            if (field === 'costCenter') {
                row.costCenter = value;
                row.costCenterId = value?.value;
                row.costCenterName = value?.label;
            } else {
                row[field] = value;
            }
            rows[index] = row;
            return rows;
        });
    };

    const handleAddCostCenterRow = () => {
        setCostCenterRows((prev) => [...prev, createEmptyCostCenterRow()]);
    };

    const handleRemoveCostCenterRow = (index: number) => {
        setCostCenterRows((prev) => {
            const rows = [...prev];
            rows.splice(index, 1);
            return rows.length ? rows : [createEmptyCostCenterRow()];
        });
    };

    const handleSaveCostCenters = () => {
        if (activeCostCenterIndex === null) {
            return;
        }
        const sanitized = costCenterRows
            .filter((row) => (row.costCenter || row.costCenterId) && row.amount !== '')
            .map((row) => ({
                costCenter: row.costCenter,
                costCenterId: row.costCenter?.value ?? row.costCenterId,
                costCenterName: row.costCenter?.label ?? row.costCenterName,
                amount: row.amount,
                remarks: row.remarks,
            }));

        const ledgerEntry = entries[activeCostCenterIndex];
        const ledgerAmount = Number(ledgerEntry?.drAmount || ledgerEntry?.crAmount || 0);
        const totalCostCenterAmount = sanitized.reduce((sum, row) => sum + Number(row.amount || 0), 0);
        if (sanitized.length && Math.abs(totalCostCenterAmount - ledgerAmount) > 0.0001) {
            toast(
                <strong>
                    Cost center total ({numberFormat(totalCostCenterAmount)}) must equal ledger amount ({numberFormat(ledgerAmount)})
                </strong>,
                { type: 'error', position: 'bottom-right', autoClose: 4000 }
            );
            return;
        }

        setEntries((prev) => {
            const updated = [...prev];
            updated[activeCostCenterIndex] = {
                ...updated[activeCostCenterIndex],
                costCenters: sanitized,
            };
            return updated;
        });
        setShowCostCenterModal(false);
        setActiveCostCenterIndex(null);
        setCostCenterRows([createEmptyCostCenterRow()]);
    };

    const handleCloseCostCenterModal = () => {
        setShowCostCenterModal(false);
        setActiveCostCenterIndex(null);
        setCostCenterRows([createEmptyCostCenterRow()]);
    };


    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = event.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleSubmit = async (event: React.FormEvent) => {
        event.preventDefault();
        setLoading(true);
        for (let i = 0; i < entries.length; i++) {
            const entry = entries[i];
            const costCenters = entry.costCenters || [];
            if (costCenters.length > 0) {
                const ledgerAmount = Number(entry.drAmount || entry.crAmount || 0);
                const totalCostCenterAmount = costCenters.reduce((sum, cc) => sum + Number(cc.amount || 0), 0);
                if (Math.abs(totalCostCenterAmount - ledgerAmount) > 0.0001) {
                    toast(<strong>Row {i + 1}: Cost center amounts must equal the ledger amount.</strong>, { type: 'error', position: 'bottom-right', autoClose: 4000 });
                    setLoading(false);
                    return;
                }
            }
        }

        const mappedEntries = entries.map((entry: any) => {
            const sanitizedCostCenters = (entry.costCenters || [])
                .filter((row: ICostCenterAllocation) => (row.costCenter || row.costCenterId) && row.amount !== '')
                .map((row: ICostCenterAllocation) => ({
                    costCenterId: row.costCenter?.value ?? row.costCenterId,
                    amount: Number(row.amount),
                    remarks: row.remarks,
                }));

            const mappedEntry: any = {
                ledger: entry.ledger,
                drAmount: entry.drAmount,
                crAmount: entry.crAmount,
                remarks: entry.remarks,
                costCenters: sanitizedCostCenters,
            };

            if (entry.idAccVoucherRows) {
                mappedEntry.idAccVoucherRows = entry.idAccVoucherRows;
            }

            return mappedEntry;
        });

        const postData = {
            ...formData,  // Spreads all formData properties
            entries: mappedEntries // Adds entries array
        };

        try {
            const response = await fetch(process.env.REACT_APP_API_URL + 'transaction/store', postRequestOptions(postData));

            const data = await response.json();
            // console.log(data, 'data');

            if (data.success) {
                toast(<strong>Voucher created successfully</strong>, { type: 'success', position: 'bottom-right', autoClose: 3000 });
                handleClose(false);
            } else {

                if (data?.errorMessage) {
                    toast(data?.errorMessage, { type: 'error', position: 'bottom-right', autoClose: 4000 });
                }

                for (const i in data.errors) {
                    toast(<strong>{data.errors[i].join(' ')}</strong>, { type: 'error', position: 'bottom-right', autoClose: 4000 });
                }
            }
        } catch (error) {
            console.error('Error submitting data:', error);
        } finally {
            setLoading(false);
        }
    };

    const drAmountTotal = entries.reduce((acc, entry) => {
        return acc + Number(entry.drAmount || 0);
    }, 0);
    
    const crAmountTotal = entries.reduce((acc, entry) => {
        return acc + Number(entry.crAmount || 0);
    }, 0);
    
    

    return (
        <>
        <Modal show={show} onHide={() => handleClose(false)}  fullscreen={true} animation={true} dialogClassName="modal-dialog-scrollable">
        <Modal.Header closeButton>
            <Modal.Title>{cloneFromVoucherId ? 'Clone Voucher' : 'Create Voucher'}</Modal.Title>
        </Modal.Header>
        <Form onSubmit={handleSubmit}>
            <Modal.Body className="modal-body-custom" style={{ maxHeight: '70vh', overflowY: 'auto' }}>
                {cloneFromVoucherId && loading && (
                    <div className="row mb-3">
                        <div className="col-12 text-center text-muted">
                            <Spinner animation="border" size="sm" className="me-2" />
                            Loading voucher details…
                        </div>
                    </div>
                )}
                <div className="row">
                    <div className="col-12">
                        <div className="alert alert-warning" role="alert">Please add payment against sales from <Link to={`/sales-invoices`} className="text-primary">Invoice page</Link> or <Link to={`/sales-order-create`} className="text-primary">Sales Order page.</Link></div>
                    </div>
                </div>
                <div className="row">
                    <div className="offset-md-2 col-md-6">
                        <Form.Group className="mb-3 row" controlId="project">
                            <Form.Label className='col-md-4 text-end'>Project<span className="required text-danger"></span></Form.Label>
                            <div className="col-md-8">
                                <Select
                                    value={project}
                                    onChange={handleProjectChange}
                                    options={projects}
                                    menuPosition="fixed"
                                    styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                                />
                            </div>
                        </Form.Group>
                    </div>
                </div>
                <div className="row">
                    <div className="offset-md-2 col-md-6">
                        <Form.Group className="mb-3 row" controlId="project">
                            <Form.Label className='col-md-4 text-end'>Select SR</Form.Label>
                            <div className="col-md-8">
                                <Select
                                    value={sr}
                                    onChange={handleSrChange}
                                    options={srs}
                                    isDisabled={companySelectAbility}
                                    menuPosition="fixed"
                                    styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                                />
                            </div>
                        </Form.Group>
                    </div>
                </div>
                
                <div className="row">
                    <div className="offset-md-2 col-md-6">
                        <Form.Group className="mb-3 row" controlId="voucherType">
                            <Form.Label className='col-md-4 text-end'>Voucher Type</Form.Label>
                            <div className="col-md-8">
                                <Select
                                    value={voucherType}
                                    onChange={handleVoucherTypeChange}
                                    options={voucherTypes}
                                    menuPosition="fixed"
                                    styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                                />

                            </div>
                        </Form.Group>
                    </div>
                </div>
                <div className="row mb-5">
                    <div className="offset-md-2 col-md-6">
                        <Form.Group className='row' controlId="voucherDate">
                            <Form.Label className='mb-3 col-md-4 text-end'>Date <span className="text-danger">*</span></Form.Label>
                            <div className="col-md-8">
                                <Form.Control
                                    type="date"
                                    name="voucherDate"
                                    value={formData.voucherDate}
                                    onChange={handleChange}
                                    className='form-control-sm'
                                    required
                                />
                            </div>
                        </Form.Group>
                    </div>
                </div>

                {formData.voucherType !== 'journal' && (
                    <>
                        <div className="row">
                            <div className="offset-md-2 col-md-6">
                                <Form.Group className="mb-3 row" controlId="modeOfTransaction">
                                    <Form.Label className='col-md-4 text-end'>Mode of Transaction</Form.Label>
                                    <div className="col-md-8">
                                        <Select
                                            value={modeOfTransaction.value ? modeOfTransaction : null}
                                            onChange={handleModeOfTransactionChange}
                                            options={modeOfTransactions}
                                            isClearable
                                            placeholder="Select Mode of Transaction"
                                            menuPosition="fixed"
                                            styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                                        />
                                    </div>
                                </Form.Group>
                            </div>
                        </div>

                        {isChequeMode(modeOfTransaction) && (
                            <>
                                <div className="row">
                                    <div className="offset-md-2 col-md-6">
                                        <Form.Group className="mb-3 row" controlId="chequeNo">
                                            <Form.Label className='col-md-4 text-end'>Cheque No</Form.Label>
                                            <div className="col-md-8">
                                                <Form.Control
                                                    type="text"
                                                    name="chequeNo"
                                                    value={formData.chequeNo}
                                                    onChange={handleChange}
                                                    className='form-control-sm'
                                                />
                                            </div>
                                        </Form.Group>
                                    </div>
                                </div>
                                <div className="row mb-5">
                                    <div className="offset-md-2 col-md-6">
                                        <Form.Group className="mb-3 row" controlId="chequeDate">
                                            <Form.Label className='col-md-4 text-end'>Cheque Date</Form.Label>
                                            <div className="col-md-8">
                                                <Form.Control
                                                    type="date"
                                                    name="chequeDate"
                                                    value={formData.chequeDate}
                                                    onChange={handleChange}
                                                    className='form-control-sm'
                                                />
                                            </div>
                                        </Form.Group>
                                    </div>
                                </div>
                            </>
                        )}

                        {modeOfTransaction.value && !isChequeMode(modeOfTransaction) && (
                            <div className="row mb-5">
                                <div className="offset-md-2 col-md-6">
                                    <Form.Group className="mb-3 row" controlId="transactionDate">
                                        <Form.Label className='col-md-4 text-end'>Transaction Date</Form.Label>
                                        <div className="col-md-8">
                                            <Form.Control
                                                type="date"
                                                name="transactionDate"
                                                value={formData.transactionDate}
                                                onChange={handleChange}
                                                className='form-control-sm'
                                            />
                                        </div>
                                    </Form.Group>
                                </div>
                            </div>
                        )}
                    </>
                )}



                <Table bordered responsive>
                    <thead>
                        <tr>
                            <th style={{ width: '40%' }}>General Ledger</th>
                            <th style={{ width: '10%' }}>Dr Amount (Tk)</th>
                            <th style={{ width: '10%' }}>Cr Amount (Tk)</th>
                            <th style={{ width: '20%' }}>Cost Centers</th>
                            <th style={{ width: '20%' }}>Remarks</th>
                            <th style={{ width: '10%' }}>Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        {entries.map((entry, index) => (
                            <tr key={index}>
                                <td>
                                    <AsyncSelect
                                        value={entry.ledger}
                                        loadOptions={getLedgers}
                                        placeholder="Please select ledger"
                                        defaultOptions={defaultLedgers}
                                        onChange={(selectedOption) => handleLedgerChange(selectedOption, index)}
                                        menuPosition="fixed"
                                        isClearable={true}
                                        components={{ SingleValue: LedgerSingleValue }}
                                        getOptionLabel={(option) => (
                                            <>
                                                <i className='fa fa-file'></i>
                                                <span> {option.label} </span><br></br>
                                                <i className='fa fa-map-marker'></i>
                                                <span> {option.ledgerPath} </span><br></br>
                                                {option.balance != null && option.balance !== '—' && (
                                                    <span className='text-muted ms-2'> · Balance: {option.balance}</span>
                                                )}
                                            </>
                                        )}

                                    />
                                </td>
                                <td>
                                    <Form.Control
                                        type="number"
                                        name="drAmount"
                                        value={entry.drAmount}
                                        onChange={(e) => handleInputChange(index, e)}
                                        min={0}
                                        step={'any'}
                                        disabled={((formData.voucherType === 'payment' && entry?.ledger?.idBankCash !== null) || (formData.voucherType === 'receipt' && entry?.ledger?.idBankCash == null)) ? true : false}
                                    />
                                </td>
                                <td>
                                    <Form.Control
                                        type="number"
                                        name="crAmount"
                                        value={entry.crAmount}
                                        onChange={(e) => handleInputChange(index, e)}
                                        min={0}
                                        step={'any'}
                                        disabled={((formData.voucherType === 'receipt' && entry?.ledger?.idBankCash !== null) || (formData.voucherType === 'payment' && entry?.ledger?.idBankCash == null)) ? true : false}
                                    />
                                </td>
                                <td>
                                    <div className="d-flex flex-column">
                                        <button
                                            type="button"
                                            className={`btn btn-link btn-sm p-0 align-baseline ${!entry.ledger ? 'text-muted' : ''}`}
                                            disabled={!entry.ledger}
                                            onClick={() => handleOpenCostCenterModal(index)}
                                        >
                                            <i className='fa fa-tags me-1'></i>
                                            {entry.costCenters.length ? `Cost Centers (${entry.costCenters.length})` : 'Tag Cost Center'}
                                        </button>
                                        {entry.costCenters.length > 0 && (
                                            <div className="small text-muted">
                                                {entry.costCenters
                                                    .map((cc) => {
                                                        const name = cc.costCenter?.label ?? cc.costCenterName ?? '';
                                                        const amount = numberFormat(Number(cc.amount || 0));
                                                        return name ? `${name}${amount ? ` (${amount})` : ''}` : amount;
                                                    })
                                                    .filter((text) => text && text.trim().length > 0)
                                                    .join(', ')}
                                            </div>
                                        )}
                                    </div>
                                </td>
                                <td>
                                    <Form.Control
                                        type="text"
                                        name="remarks"
                                        value={entry.remarks}
                                        onChange={(e) => handleInputChange(index, e)}
                                    />
                                </td>
                                <td>
                                    <div className='d-flex'>
                                        {entries.length > 1 &&
                                            <Button className='btn btn-sm ms-2' variant="danger" onClick={() => handleRemoveRow(index)}>
                                                <i className='fa fa-trash'></i>
                                            </Button>
                                        }

                                        {index === entries.length - 1 && (
                                            <Button className='btn btn-sm ms-2' variant="primary" onClick={handleAddRow}>
                                                <i className='fa fa-plus'></i>
                                            </Button>
                                        )}
                                    </div>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                    <tfoot>
                        <tr>
                            <td className="text-end"><strong>Total</strong></td>
                            <td><strong>{numberFormat(drAmountTotal)}</strong></td>
                            <td><strong>{numberFormat(crAmountTotal)}</strong></td>
                            <td></td>
                            <td></td>
                        </tr>
                    </tfoot>
                </Table>

                <Form.Group controlId="formNarration">
                    <Form.Label>Narration</Form.Label>
                    <Form.Control
                        as="textarea"
                        rows={3}
                        name="narration"
                        value={formData.narration}
                        onChange={handleChange}
                    />
                </Form.Group>

            </Modal.Body>
            <Modal.Footer>

                <button type="submit" disabled={isSubmitDisable || loading} className="btn btn-sm btn-primary me-2">
                    {loading &&
                        <Spinner
                            as="span"
                            animation="grow"
                            size="sm"
                            role="status"
                            aria-hidden="true"
                        />
                    }
                    <span> <i className='fa fa-save'></i> Submit</span>
                </button>
                <Button variant='secondary' size="sm" onClick={() => handleClose(false)}>
                    Close
                </Button>
            </Modal.Footer>
            {/* <pre>{JSON.stringify(formData, null, 2)}</pre>
            <pre>{JSON.stringify(entries, null, 2)}</pre> */}
        </Form>
    </Modal>

    <Modal show={showCostCenterModal} onHide={handleCloseCostCenterModal} size="lg">
        <Modal.Header closeButton>
            <Modal.Title>Tag Cost Center</Modal.Title>
        </Modal.Header>
        <Modal.Body>
            <Table bordered responsive size="sm">
                <thead>
                    <tr>
                        <th style={{ width: '40%' }}>Cost Center</th>
                        <th style={{ width: '20%' }}>Amount</th>
                        <th style={{ width: '30%' }}>Remarks</th>
                        <th style={{ width: '10%' }}>Action</th>
                    </tr>
                </thead>
                <tbody>
                    {costCenterRows.map((row, idx) => (
                        <tr key={idx}>
                            <td>
                                <Select
                                    value={row.costCenter}
                                    onChange={(option) => handleCostCenterFieldChange(idx, 'costCenter', option)}
                                    options={costCenterOptions}
                                    placeholder="Select cost center"
                                    isClearable
                                    menuPosition="fixed"
                                    styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                                />
                            </td>
                            <td>
                                <Form.Control
                                    type="number"
                                    min={0}
                                    step="any"
                                    value={row.amount}
                                    onChange={(e) => handleCostCenterFieldChange(idx, 'amount', e.target.value)}
                                />
                            </td>
                            <td>
                                <Form.Control
                                    type="text"
                                    value={row.remarks}
                                    onChange={(e) => handleCostCenterFieldChange(idx, 'remarks', e.target.value)}
                                />
                            </td>
                            <td>
                                <div className='d-flex'>
                                    {costCenterRows.length > 1 && (
                                        <Button variant="danger" size="sm" onClick={() => handleRemoveCostCenterRow(idx)}>
                                            <i className='fa fa-trash'></i>
                                        </Button>
                                    )}
                                    {idx === costCenterRows.length - 1 && (
                                        <Button variant="primary" size="sm" className='ms-2' onClick={handleAddCostCenterRow}>
                                            <i className='fa fa-plus'></i>
                                        </Button>
                                    )}
                                </div>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </Table>
        </Modal.Body>
        <Modal.Footer>
            <Button variant='secondary' size="sm" onClick={handleCloseCostCenterModal}>
                Close
            </Button>
            <Button variant='primary' size="sm" onClick={handleSaveCostCenters}>
                Save
            </Button>
        </Modal.Footer>
    </Modal>
    </>
    )
}

export default JournalModal